import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-funds-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                众赢国际
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专业可靠的综合性金融服务平台，致力于为全球投资者提供安全、便捷、高效的投资交易服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容导航</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-xxx-xxxx</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>support@zhongyingguoji.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-time-line text-base"></i>
                <span>7×24小时在线服务</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 众赢国际 版权所有 | 京ICP备xxxxxxxx号
          </p>
          <p className="text-xs text-background-500">
            投资有风险，入市需谨慎。本网站内容仅供参考，不构成投资建议。
          </p>
        </div>
      </div>
    </footer>
  );
}